import React, {useState} from "react";
import {formatDate, formatDateTime, useIsMobile} from "../../../../../_common/function";
import {Badge, Col, List, Modal, Row, Tag, Typography} from "antd";
import VirtualList from "rc-virtual-list";
import EmptyData from "../../../../../../brand/component/emptyData/view";
import Loader from "../../../../../../brand/component/loader/view";
import {updateUserAnnouncementReadStatus} from "../../../../../api/graphql/announcement";
import {useSetRecoilState} from "recoil";
import {globalUnreadAnnouncementCountState} from "../../../../../_common/global_state";

const {Paragraph} = Typography

const CONTAINER_HEIGHT = 400;

const AnnouncementListing_3 = (props) => {
    const {
        isHeader,
        data,
        loading,
    } = props
    const isMobile = useIsMobile();

    const [selected, setSelected] = useState({})
    const [modalOpen, setModalOpen] = useState(false);
    const [currentData, setCurrentData] = useState({})
    const [updatedRead, setUpdatedRead] = useState([])

    const setUnreadAnnouncementCount = useSetRecoilState(globalUnreadAnnouncementCountState);

    const renderTinyMCEContent = (content) => {
        return <div className={"tinyMceParagraph"} dangerouslySetInnerHTML={{__html: content}}/>;
    };

    const selectItem = () => {
        setSelected({})
    }

    const loadingComponent = (
        <Col span={24} className={"text-center mb-6"}>
            <div className={"min-h-[400px]"}>
                <Loader/>
            </div>
        </Col>
    )

    const dateToday = formatDate(new Date(), true, "YYYY-MM-DD")

    const listComponent = (
        <List>
            <VirtualList
                className={"cursor-pointer"}
                data={data}
                height={CONTAINER_HEIGHT}
                itemHeight={47}
                itemKey={"stock"}
            >
                {(item) => {
                    const title = item?.dataOfObject?.title
                    const description = item?.dataOfObject?.description
                    const time = item?.createdAt
                    const isToday = formatDate(time, true, "YYYY-MM-DD") === dateToday

                    return (
                        <div
                            key={item?._id}
                            className={"mb-2 text-start announcement-card"}
                            onClick={async () => {
                                if (isHeader) {
                                    setCurrentData(item)
                                    setModalOpen(true);
                                    if (!item?.isRead && !updatedRead.includes(item?._id)) {
                                        const res = await updateUserAnnouncementReadStatus([item?._id], true)
                                        if (res?.updateUserAnnouncementReadStatus[0]?.isRead) {
                                            setUpdatedRead(prev => [...prev, res?.updateUserAnnouncementReadStatus[0]?._id])
                                            setUnreadAnnouncementCount(prev => prev - 1)
                                        }
                                    } else if (item?.isAnnouncementUpdated && !updatedRead.includes(item?._id)) {
                                        const res = await updateUserAnnouncementReadStatus([item?._id], true)
                                        setUpdatedRead(prev => [...prev, res?.updateUserAnnouncementReadStatus[0]?._id])
                                    }
                                } else {
                                    selectItem()
                                }
                            }}
                        >
                            <Row align={"middle"} wrap={false}>
                                <Col flex={"auto"}>
                                    <Row wrap={false}>
                                        {!item?.isRead && !updatedRead.includes(item?._id) && (
                                            <Col span={2}>
                                                <Badge dot offset={[-2, 3]}/>
                                            </Col>
                                        )}
                                        <Col span={!item?.isRead && !updatedRead.includes(item?._id) ? 22 : 24}>
                                            <Paragraph className={"title"} ellipsis>
                                                {title}
                                            </Paragraph>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col className={"text-end"}>
                                    <div className={"date-time"}>
                                        {formatDateTime(time, isToday ? "hh:mm A" : "DD/MM, hh:mm A")}
                                    </div>
                                </Col>
                            </Row>
                            <Row wrap={false} align={"middle"}>
                                <Col flex={"auto"}>
                                    <Paragraph ellipsis={{rows: 2}} className={"description"}>
                                        {description}
                                    </Paragraph>
                                </Col>
                                {item?.isAnnouncementUpdated && !updatedRead.includes(item?._id) && (
                                    <Col>
                                        <Tag className={"announcement-updated-tag"} color="processing">
                                            Updated
                                        </Tag>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    )
                }}
            </VirtualList>
        </List>
    )

    const emptyComponent = (
        <div className={"mx-auto mt-6"}>
            <EmptyData/>
        </div>
    )

    return (
        <div id={"announcementListing"}>
            {loading ? loadingComponent : !!data?.length ? listComponent : emptyComponent}
            <Modal
                title={
                    <>
                        {currentData?.dataOfObject?.title}
                        <p className={"date-time"}>
                            {formatDateTime(currentData?.dataOfObject?.createdAt, "MMMM Do YYYY, h:mm:ss a")}
                            {currentData?.announcementUpdatedAt && ` (Last updated on ${formatDateTime(currentData?.announcementUpdatedAt, "MMMM Do YYYY, h:mm:ss a")})`}
                        </p>
                    </>
                }
                width={isMobile ? "90%" : "60%"}
                open={modalOpen}
                footer={null}
                onCancel={() => setModalOpen(false)}
                className={"announcement-modal"}
                getContainer={() => document.querySelector("#layout-3")}
            >
                <p>{currentData?.dataOfObject?.description}</p>
                <div className={"mt-4"}>{renderTinyMCEContent(currentData?.dataOfObject?.content)}</div>
            </Modal>
        </div>
    )
}

export default AnnouncementListing_3;